import { useTranslation } from 'react-i18next'
import { Button } from '../common/Button'

interface ComingSoonModalProps {
  onClose: () => void
}

/**
 * "Coming soon" modal for AI-guided voice mode
 * Shows when user selects AI-guided option (per product team decision)
 */
export function ComingSoonModal({ onClose }: ComingSoonModalProps) {
  const { t } = useTranslation()

  const overlayStyles = {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    zIndex: 1000,
  }

  const modalStyles = {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '2rem',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  }

  const titleStyles = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#1a1a1a',
    marginBottom: '1rem',
    textAlign: 'center' as const,
  }

  const messageStyles = {
    fontSize: '16px',
    color: '#666',
    lineHeight: 1.6,
    marginBottom: '2rem',
    textAlign: 'center' as const,
  }

  return (
    <div style={overlayStyles} onClick={onClose}>
      <div style={modalStyles} onClick={e => e.stopPropagation()}>
        <h2 style={titleStyles}>{t('onboarding.comingSoon.title')}</h2>
        <p style={messageStyles}>{t('onboarding.comingSoon.message')}</p>
        <Button fullWidth onClick={onClose}>
          {t('onboarding.comingSoon.continueButton')}
        </Button>
      </div>
    </div>
  )
}
